export const TRUTHY_REGEXP = /^1|t(rue)?$/
export const FALSY_REGEXP = /^0|f(alse)?$/
